import('./bootstrap').catch((err) => console.error('ERROR AL CARGAR EL ARCHIVO -> ', err));
